<div class="total-amount-summary__wrapper">
    <h5 class="total-amount-summary__title" skeletonLoader [translationKey]="titleKey">
		{{title}}
	</h5>
    <!-- currently no basis from the API regarding the original price
	<div class="total-amount-summary__original-price"  
		tabindex=0 
		[attr.aria-label]="'review.totalAmountSummary.aria.originalPrice' | ibeadmin | async">
		{{INDRA_printOriginalPrice() | indracurrency}}
	</div>
	-->
    <div class="total-amount-summary__final-price" [ngClass]="{'is-loading': (loading$ |async) }">
        <app-loading-circle class="total-amount-summary__loading" *ngIf="(loading$ |async)"></app-loading-circle>
        <span class="total-amount-summary__final-price--miles" *ngIf="INDRA_printMiles() && !isCorporate" tabindex=0 [attr.aria-label]="'review.totalAmountSummary.aria.milesSelected' | ibeadmin | async">
			{{ INDRA_printMiles() | indracurrency }}
		</span>
        <span class="total-amount-summary__final-price--sum" *ngIf="INDRA_printMiles() && !isCorporate"> + </span>
        <span class="total-amount-summary__final-price--cash" tabindex=0 [attr.aria-label]="'review.totalAmountSummary.aria.finalPriceCash' | ibeadmin | async">	
			{{INDRA_printFinalPrice() | indracurrency}}
		</span>
    </div>

    <div class="total-amount-summary__links">
        <a href="javascript:;" class="link" (click)=INDRA_handleTaxesAndCharges() [attr.aria-label]="'review.totalAmountSummary.aria.openDialogTaxesFees' | ibeadmin | async" *ngIf="!isTTTBookingView && showTaxes">
			<span skeletonLoader [translationKey]="'review.totalAmountSummary.text.taxesFees'">
				{{'review.totalAmountSummary.text.taxesFees' | ibeadmin | async}}
			</span>
		</a>
        <a href="javascript:;" class="link" (click)=INDRA_handlePriceBreakdown() [attr.aria-label]="'review.totalAmountSummary.aria.openDialogPriceBreakdown' | ibeadmin | async">
			<span skeletonLoader [translationKey]="'review.totalAmountSummary.text.priceBreakdown'">
				{{'review.totalAmountSummary.text.priceBreakdown' | ibeadmin | async}}
			</span>
		</a>
    </div>
</div>